import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ProductsService } from 'src/app/shared/services/products/products.service';
import { CHANNEL as CHANNEL_CONSTANS, navCode } from '../../../../shared/constants/channel.constants';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-Input-Amount',
  templateUrl: './Input-Amount.component.html',
  styleUrls: ['./Input-Amount.component.scss'],
})
export class InputAmountComponent implements OnInit {
  formGroup: FormGroup;
  formGroupSelect: FormGroup;

  maxPeriod: any;
  taxRates: any;
  activeInput = false;
  showRate = false;
  amount: any;
  amountModel: any;
  reactiveErrormonto: '';
  option = 'number';

  constructor(

    public copyService: CopyService,
    private navigationService: NavigationService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private formBuilder: FormBuilder,
    private productService: ProductsService,
    private bitacoraService: BitacoraService,
    private cdr: ChangeDetectorRef,
    private helperService: HelpersService,
  ) {
    this.headerService.show(true, false, true);
    this.formGroup = this.formBuilder.group({});
  }

  ngOnInit() {
    this.amount = this.abreCuentasService.getSaveValueInputAmount();
    if (this.amount !== undefined && this.amount !== 0 && this.amount !== null) {
      const amountFormat = this.helperService.currency(this.amount.toString());
      this.formGroup = new FormGroup({
        monto: new FormControl(amountFormat.format, [
          Validators.required,
          Validators.min(10000)]),
      });
    } else {
      this.formGroup = new FormGroup({
        monto: new FormControl('', [
          Validators.required,
          Validators.min(10000)]),
      });
    }
  }

  updateValuemonto(event: any) {
    const value = event.target.value;
    const newvalue = this.helperService.currency(value);
    if (+ newvalue.clearValue < 10000) {
      console.log('lanzo error ');
    }
    // valor = valor.replace('$ ', '').split(/\./).join('');
    this.formGroup.controls['monto'].setValue(newvalue.clearValue);
    event.target.value = newvalue.format;

  }

  reactiveInputChangeMonto() {
    const MontoControl = this.formGroup.controls.monto as FormControl;
    this.reactiveErrormonto = MontoControl.valid ? '' : this.copyService.copies.monto_monto_error;
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterContentInit(): void {

    this.headerService.show(true, false, true);
    this.cdr.detectChanges();
  }

  reactiveInputChangeAmount() {
    const controlAmount = this.formGroup.controls['monto'] as FormControl;
    const value = controlAmount.value.split('.');
    this.amount = value[0];
  }
  /**
   *  Summary Handless the onFocus event
   */
  reactiveOnFocus() {
    this.activeInput = true;
  }
  next() {
    const amountFormat = this.helperService.currency(this.formGroup.controls['monto'].value.toString());
    this.amount = amountFormat;
    const bitacoraEvent = `monthly_payment_value_purchase_credit_${this.formGroup.controls['monto'].value}`;
    console.log(bitacoraEvent);
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    this.abreCuentasService.setSaveValueInputAmount(this.amount.clearValue);
    this.navigateFlow();
  }

  navigateFlow() {
    let nav = false;
    if (this.abreCuentasService.chanelid === CHANNEL_CONSTANS.PORTALO.CODE && this.abreCuentasService.getRequestEntity() !== 2) {
      nav = true;
    }
    switch (nav) {
      case true:
        this.navigationService.nextStep(navCode[201]);
        break;
      default:
        this.navigationService.nextStep(navCode[200]);
        break;
    }
  }

}
